import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { RESPONSIBLE_GAMING_ACTION_TYPE } from "./responsible-gaming.action";
import { ResponsibleGamingState } from "./responsible-gaming.model";

const initialState: ResponsibleGamingState = {
	sessionDurationMinutes: 0,
};

export function responsibleGamingReducer(state = initialState, action: ActionWithPayload): ResponsibleGamingState {
	switch (action.type) {
		case RESPONSIBLE_GAMING_ACTION_TYPE.sessionLimitExpired: {
			return updateState(state, {
				sessionDurationMinutes: action.payload,
			});
		}
		case RESPONSIBLE_GAMING_ACTION_TYPE.stopSessionLimitCheck: {
			return updateState(state, {
				sessionDurationMinutes: 0,
			});
		}
		default:
			return state;
	}
}
